import { useState } from "react";
import AddHouse from "./AddHouse";
import MyHouses from "./MyHouses";
import EditProperty from "./EditProperty";
function LandlordDashboard({ onLogout }) {
  const [view, setView] = useState("home");
const [selectedProperty, setSelectedProperty] = useState(null);
  if (view === "add") {
    return <AddHouse goBack={() => setView("home")} />;
  }

  if (view === "my") {

  return (

    <MyHouses

      goBack={() => setView("home")}

      onEdit={(property) => {

        setSelectedProperty(property);

        setView("edit");

      }}

    />

  );

}
if (view === "edit") {

  return (

    <EditProperty

      property={selectedProperty}

      goBack={() => setView("my")}

      onSave={() => {

        setSelectedProperty(null);

        setView("my");

      }}

    />

  );

}
  const buttonStyle = (bg) => ({
    width: "100%",
    padding: "16px",
    backgroundColor: bg,
    color: "white",
    border: "none",
    borderRadius: "14px",
    cursor: "pointer",
    fontSize: "17px",
    fontWeight: "bold",
    marginTop: "15px",
    transition: "0.2s ease",
    letterSpacing: "0.5px"
  });

  const cardStyle = {
    backgroundColor: "white",
    borderRadius: "25px",
    padding: "35px",
    textAlign: "center",
    boxShadow: "0 12px 30px rgba(0,0,0,0.18)",
    minHeight: "280px"
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(135deg, #0a0a0a, #1a1a1a, #ffd600)",
        padding: "50px 25px"
      }}
    >
      <div style={{ maxWidth: "1200px", margin: "auto" }}>

        {/* HEADER */}
        <div
          style={{
            backgroundColor: "white",
            borderRadius: "30px",
            padding: "50px 40px",
            textAlign: "center",
            boxShadow: "0 15px 35px rgba(0,0,0,0.25)",
            marginBottom: "45px"
          }}
        >
          <h1
            style={{
              fontSize: "52px",
              marginBottom: "10px"
            }}
          >
            🏢 MNHouseFinder
          </h1>

          <h2 style={{ color: "#ffd600", marginBottom: "15px" }}>
            Landlord Dashboard
          </h2>

          <p style={{ color: "#444", fontSize: "18px", lineHeight: "1.8" }}>
            Manage residential and commercial properties easily from one dashboard.
          </p>
        </div>

        {/* MAIN CARDS */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
            gap: "35px",
            marginBottom: "45px"
          }}
        >

          {/* ADD PROPERTY */}
          <div style={cardStyle}>
            <div style={{ fontSize: "65px" }}>➕</div>

            <h2 style={{ color: "#2e7d32", marginTop: "10px" }}>
              Add Property
            </h2>

            <p style={{ color: "#555", lineHeight: "1.7", marginTop: "10px" }}>
              Post new residential or commercial properties for tenants to view and rent.
            </p>

            <button
              style={buttonStyle("#2e7d32")}
              onClick={() => setView("add")}
            >
              ➕ Add Property
            </button>
          </div>

          {/* MY PROPERTIES */}
          <div style={cardStyle}>
            <div style={{ fontSize: "65px" }}>🏘️</div>

            <h2 style={{ color: "#1565c0", marginTop: "10px" }}>
              My Properties
            </h2>

            <p style={{ color: "#555", lineHeight: "1.7", marginTop: "10px" }}>
              View, edit, and manage all your listed properties in one place.
            </p>

            <button
              style={buttonStyle("#1565c0")}
              onClick={() => setView("my")}
            >
              🏘️ View Properties
            </button>
          </div>
        </div>

        {/* PROPERTY TYPES */}
        <div
          style={{
            backgroundColor: "white",
            borderRadius: "30px",
            padding: "40px",
            boxShadow: "0 12px 30px rgba(0,0,0,0.18)",
            marginBottom: "45px"
          }}
        >
          <h2 style={{ textAlign: "center", marginBottom: "30px" }}>
            📌 Supported Property Categories
          </h2>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
              gap: "30px"
            }}
          >

            <div style={{ lineHeight: "1.8" }}>
              <h3>🏠 Residential</h3>
              <ul>
                <li>Single Room</li>
                <li>Bedsitter</li>
                <li>Double Room</li>
                <li>Apartments</li>
                <li>Mansionettes</li>
                <li>Bungalows</li>
              </ul>
            </div>

            <div style={{ lineHeight: "1.8" }}>
              <h3>🏢 Commercial</h3>
              <ul>
                <li>Office Space</li>
                <li>Shops</li>
                <li>Commercial Buildings</li>
                <li>Business Premises</li>
              </ul>
            </div>

          </div>
        </div>

        {/* LOGOUT */}
        <div style={{ textAlign: "center" }}>
          <button
            style={{
              width: "260px",
              padding: "16px",
              backgroundColor: "#d32f2f",
              color: "white",
              border: "none",
              borderRadius: "14px",
              fontSize: "18px",
              fontWeight: "bold",
              cursor: "pointer"
            }}
            onClick={onLogout}
          >
            🚪 Logout
          </button>
        </div>

      </div>
    </div>
  );
}

export default LandlordDashboard;